module.exports = __webpack_public_path__ + "img/logo-iris-global.08df0cc9.png";